import "./footer.css";
import LogoColor from "../../assets/logo/LogoColor.png";
import FacebookIcon from "../icons/FacebookIcon";
import InstagramIcon from "../icons/InstagramIcon";
import LinkedinIcon from "../icons/LinkedinIcon";

const rrss = [
  {
    id: 1,
    name: "Facebook",
    icon: <FacebookIcon size={16} color="currentColor" />,
    url: "https://www.facebook.com/distribucionesstock",
  },
  {
    id: 2,
    name: "Instagram",
    icon: <InstagramIcon size={16} color="currentColor" />,
    url: "https://www.instagram.com/stock.distribuciones/",
  },
  {
    id: 3,
    name: "Linkedin",
    icon: <LinkedinIcon size={16} color="currentColor" />,
    url: " https://www.linkedin.com/company/stock-distribuciones/",
  },
];

const Footer = () => {
  return (
    <footer>
      <div className="footer-container">
        <div className="content-top">
          <img src={LogoColor} alt="Logo Stock Distribuciones" />
          <div className="text-content">
            <p className="mb-0">info@stockar.com.ar</p>
            <p className="mb-0">Tel.: 0800-777-6468</p>
          </div>
        </div>
        <div className="content-bottom">
          <div className="btns-rrss">
            {rrss.map((red) => (
              <div key={red.id}>
                <button
                  className="btn-rrss"
                  onClick={() => window.open(red.url, "_blank")}
                >
                  <span className="icon-wrapper">{red.icon}</span>
                  {red.name}
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div>
        <p className="mb-0 copyright">images: www.freepik.es</p>
      </div>
    </footer>
  );
};

export default Footer;
